/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DdtSubjectCreateDto } from '../../models/ddt-subject-create-dto';
import { DdtSubject } from '../../models/ddt-subject';

export interface DdtControllerUpdateSubject$Params {
  id: number;
      body: DdtSubjectCreateDto
}

export function ddtControllerUpdateSubject(http: HttpClient, rootUrl: string, params: DdtControllerUpdateSubject$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DdtSubject;
}>> {
  const rb = new RequestBuilder(rootUrl, ddtControllerUpdateSubject.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: DdtSubject;
      }>;
    })
  );
}

ddtControllerUpdateSubject.PATH = '/ddt/subject/{id}';
